import { render, staticRenderFns } from "./SolutionSection.vue?vue&type=template&id=2ff39853&scoped=true&lang=html&"
import script from "./SolutionSection.vue?vue&type=script&lang=js&"
export * from "./SolutionSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff39853",
  null
  
)

export default component.exports